import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';
import { AlertService } from '../../alertpopup/_alert';
export class UserData {
  NDList: NotificationUserData [];
  UserData: UserMaster[];
}
export class UserMaster {
  ID: any;
  UserName: string;
  Email: string;
  Mobile: any;
}
export class InsertNotifyData {
  NDList: [];
  recEnable: string;
}
export class NotificationUserData {
  ID: any;
  UserName: string;
  Email: string;
  Mobile: any;
  EmailEmployee = [];
  SMSEmployee = [];
  recEnable: any;
  SelectedEmail: number [];
  SelectedSms: number [];
  IsClient: any;
}

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    standalone: false
})
export class NotificationComponent implements OnInit {
  @Input() NotificationData: NotificationUserData[];
  url: string;
  Module: any;
  Features: any;
  MsgType: number;
  DisplayMessage: string;
  MainID: string;
  FormSearchNotification: FormGroup;
  Form: FormGroup;
  isSelected: boolean;
  UserMasterDetail: any;
  HideContent: string;
  ReportID: string;
  MailRoute: string;
  isSelectedClient: boolean;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.HideContent = "!isHidden";
    this.MsgType = 1; // Loading
    this.FormSearchNotification = this.formBuilder.group ({
      Module: [''], Feature: [''], recEnable: [''], IsMailToClient:[''] });
    this.FormSearchNotification.patchValue({ Module: '0' , Feature: '0' });
    // Fetch Module in Notification
    this.http.get(this.url + 'AlertNotificationDetail/Fetch_Notification_Header_Module?MainID=' + '') .subscribe( (data) => {
      this.Module = JSON.parse(data.toString()); });
    this.isSelected = false;
    this.isSelectedClient = false;
    const formGroup = {};
    this.Form = new FormGroup(formGroup);
//
  }
  onModuleSelect(ModuleID) {
  this.Features = null;
  this.http.get(this.url + 'AlertNotificationDetail/Fetch_Notification_Header_Module?MainID=' + ModuleID) .subscribe( (data) => {
    this.Features = JSON.parse(data.toString()); });
  this.FormSearchNotification.patchValue({ Feature: '0' });
  this.HideContent = "!isHidden";
  }
  SaveData()  {
    // tslint:disable-next-line: max-line-length
    this.http.post(this.url + 'AlertNotificationDetail/Insert_Notification_Data', this.Form.value) .subscribe( (data) => {
      this.alertService.success('Successfully Submit', this.options);
      if (data == null) {
     }});
  }
  onChange(ischeck)  {
    for (var val of this.NotificationData) {
      (this.Form.get(String('recEnable|' + val.ID)) as FormControl).patchValue(ischeck.target.checked==false?0:1);
   }
  }
  onChangeClientMail(ischeck){
    for (var val of this.NotificationData) {
      (this.Form.get(String('IsClient|' + val.ID)) as FormControl).patchValue(ischeck.target.checked==false?0:1);
   }
  }
  print() {
    window.print();
  }
  onFeatureSelect(SubID) {
    this.HideContent = "";
    if ( SubID < 1 ) {  this.HideContent = "!isHidden";  }
    if (SubID == 1) {this.MailRoute = '/editor/M94'; }
    if (SubID == 2) {this.MailRoute = '/editor/M95'; }
    if (SubID == 3) {this.MailRoute = '/editor/M96'; }
    if (SubID == 4) {this.MailRoute = '/editor/M97'; }
    if (SubID == 5) {this.MailRoute = '/editor/M98'; }
    if (SubID == 6) {this.MailRoute = '/editor/M99'; }
    if (SubID == 7) {this.MailRoute = '/editor/M88'; }
    if (SubID == 8) {this.MailRoute = '/editor/M89'; }
    if (SubID == 9) {this.MailRoute = '/editor/M90'; }
    const formGroup = {};
    this.ReportID = SubID;
    this.Form = new FormGroup(formGroup);

    this.isSelected = false;
    this.http.get(this.url + 'AlertNotificationDetail/Fetch_User_Notificate_Listing?FeatureID=' + SubID)
    .subscribe( (data) => {
      console.log(data);
      if (data == null || data.toString() == "[]") {
        this.MsgType = 2; // No Data Found
        this.DisplayMessage = "No Data Found";
        let notificationUserData: NotificationUserData [] = null;
        let userMaster: UserMaster[] = null;
        this.HideContent = "";
      } else {
      this.HideContent = "";
      this.MsgType = 0; // No Message
      let userData: UserData = JSON.parse(data.toString());
      let notificationUserData: NotificationUserData [] = userData.NDList;
      this.NotificationData = userData.NDList;
      let userMaster: UserMaster[] = userData.UserData;
      this.UserMasterDetail = userData.UserData;
      if (notificationUserData[0].recEnable == 0) {
        this.isSelected = false;
      } else { this.isSelected = true; }
      if (notificationUserData[0].IsClient == 0) {
        this.isSelectedClient = false;
      } else { this.isSelectedClient = true; }
      }
      this.NotificationData.forEach(notificationData => {
         formGroup['Report'] = new FormControl("");
         formGroup['ID|' + notificationData.ID] = new FormControl("");
         formGroup['EmailManager|' + notificationData.ID] = new FormControl("");
         formGroup['Email|' + notificationData.ID] = new FormControl("");
         formGroup['SmsManager|' + notificationData.ID] = new FormControl("");
         formGroup['Sms|' + notificationData.ID] = new FormControl("");
         formGroup['IsClient|' + notificationData.ID] = new FormControl("");
         formGroup['recEnable|' + notificationData.ID] = new FormControl("");
         this.Form = new FormGroup(formGroup);
       });
       (this.Form.get(String('Report')) as FormControl).patchValue(SubID);
      for (var val of this.NotificationData) {
         (this.Form.get(String('ID|' + val.ID)) as FormControl).patchValue(val.ID);
         val.SelectedEmail = val.EmailEmployee.toString().split(',').map(Number);
         (this.Form.get(String('EmailManager|' + val.ID)) as FormControl).patchValue(val.SelectedEmail);
         (this.Form.get(String('Email|' + val.ID)) as FormControl).patchValue(val.Email);
         val.SelectedSms = val.SMSEmployee.toString().split(',').map(Number);
         (this.Form.get(String('SmsManager|' + val.ID)) as FormControl).patchValue(val.SelectedSms);
         (this.Form.get(String('Sms|' + val.ID)) as FormControl).patchValue(val.Mobile);
         (this.Form.get(String('IsClient|' + val.ID)) as FormControl).patchValue(val.recEnable);
         (this.Form.get(String('recEnable|' + val.ID)) as FormControl).patchValue(val.recEnable);
      }
    },
    (error) => {
       this.MsgType = 3; // Error Message
       this.DisplayMessage = error.message;
     }
  );

  }
}
